import { createEffect } from 'effector'
import { onError } from '@/app/routing/events'

import { getTasks, postClaimTaskRewrd } from './api'
import { postStartTask } from './api'

export const getTasksFx = createEffect(async ({ token }: { token: string }) => {
  if (token) {
    try {
      const response = await getTasks(token)
      return response
    } catch {
      return []
    }
  }
  return []
})

getTasksFx.failData.watch(() => {
  onError()
})
type startTaskParams = {
  token: string
  task_id: number
}
export const checkTaskFx = createEffect(async ({ token, task_id }: startTaskParams) => {
  if (!token) {
    throw new Error('no token')
  }
  try {
    const response = await postStartTask(token, task_id)
    return response
  } catch {
    return { ok: false }
  }
})

export const claimTaskRewardFx = createEffect(async ({ token, task_id }: startTaskParams) => {
  if (token) {
    const response = await postClaimTaskRewrd(token, task_id)
    return response
  } else throw new Error('no token')
})
claimTaskRewardFx.failData.watch(() => {
  onError()
})
